<template>
    <div 
        :class="[
            'loader',
            { 'is-active': isActive }
        ]"
    >
        <span 
            v-for="i in 4" 
            :key="i"
        />
    </div>
</template>

<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            required: false,
            default: true
        }
    }
}
</script>

<style lang="scss">
.loader {
    $balls-count: 4;
    $ball-radius: 6px;
    $ball-iteration-time: .8s;
    $ball-space: $ball-radius / 2;

    @include hide();
    position: absolute;
    top: calc(50% - #{$ball-radius});
    left: calc(50% - #{($balls-count * $ball-radius + ($balls-count - 1) * $ball-space) / 2});

     &.is-active {
        @include show();
    }

    > span {
        @include size($ball-radius);
        @include border-circle();
        @include transform(scale(.618));
        background-color: $color-primary;
        display: inline-block;
        position: absolute;
        animation: loader-spin $ball-iteration-time linear 0s infinite;
        opacity: 0;

        @for $i from 1 through $balls-count {
            &:nth-child(#{$i}) {
                left: #{($i - 1) * ($ball-radius + $ball-space)};

                @if $i % 2 == 1 {
                    animation-delay: $ball-iteration-time / 2;
                }
                @else {
                    animation-delay: $ball-iteration-time;
                }
            }
        }
    }
}

@include keyframes(loader-spin) {
    0% {
        @include transform(scale(.618));
        opacity: 0;
    }

    20% {
        @include transform-none();
        opacity: 1;
    }

    60% {
        @include transform-none();
        opacity: 1;
    }

    80% {
        @include transform(scale(.618));
        opacity: 0;
    }

    100% {
        @include transform(scale(.618));
        opacity: 0;
    }
}
</style>